import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function ImageSplitLayout() {
  return <section id="imagesplitlayout" className="w-full bg-background flex justify-center items-center !p-0">
      <div className="w-full max-w-[1364px] !h-[455px] !p-0">
        <div className="flex flex-col md:flex-row w-full overflow-hidden">
          {}
          <div className="w-full md:w-1/2 border border-border bg-muted/20 relative">
            <AspectRatio ratio={3 / 2} className="!w-[682px] !h-[455px] !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/Combien-de-sacs-de-laine-de-roche-pour-isoler-100m²-682x455-1.png)] !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/isolation-maison-ancienne682x455.png)]">
              
              {}
              <div className="absolute inset-0 ring-1 ring-inset ring-black/5 pointer-events-none"></div>
            </AspectRatio>
          </div>

          {}
          <div className="w-full md:w-1/2 border border-t-0 md:border-t md:border-l-0 border-border bg-muted/20 relative">
            <AspectRatio ratio={3 / 2} className="!w-[682px] !h-[455px] !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/isolation-maison-ancienne682x455.png)] !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/istockphoto-480954618-682x455-1.png)] !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/isolation-maison-ancienne682x455.png)]">
              
              {}
              <div className="absolute inset-0 ring-1 ring-inset ring-black/5 pointer-events-none"></div>
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}